import React, { type ButtonHTMLAttributes } from 'react';

import { twMerge } from 'tailwind-merge';

export const Button = React.forwardRef(
  (
    props: ButtonHTMLAttributes<HTMLButtonElement>,
    ref: React.Ref<HTMLButtonElement> | undefined,
  ) => {
    const { className, ...other } = props;

    return (
      <button
        ref={ref}
        className={twMerge(
          `bg-primary hover:bg-primary focus-visible:bg-primary flex w-fit justify-center 
        rounded-md p-3 text-sm font-semibold leading-6 text-white focus-visible:outline 
        focus-visible:outline-2 focus-visible:outline-offset-2 disabled:cursor-not-allowed disabled:opacity-70`,
          className,
        )}
        {...other}
      />
    );
  },
);
